import React from "react";
import {withScriptjs, withGoogleMap, GoogleMap} from "react-google-maps";
import StoreMarker from "./StoreMarker";
import LocationSearchInput from "./LocationSearchInput";

const Map = withScriptjs(
  withGoogleMap(props => {
    const searchBox = (
      <LocationSearchInput
        onPlaceSelected={props.onPlaceSelected}
        onCenterChanged={props.setCenterOnPlaceSelected}
      />
    );

    const markers = (
      <StoreMarker
        location={
          props.store &&
          props.store.location &&
          (props.store.location.lat !== "" || props.store.location.lng !== "")
            ? {
                lat: props.store.location.lat,
                lng: props.store.location.lng
              }
            : props.location &&
              (props.location.lat !== "" || props.location.lng !== "")
            ? {
                lat: props.location.lat,
                lng: props.location.lng
              }
            : {
                lat: 59.3293,
                lng: 18.0686
              }
        }
      />
    );

    return (
      <GoogleMap
        onClick={props.onMapClick}
        ref={props.onMapMounted}
        center={props.center}
        defaultZoom={10}
        defaultOptions={{
          fullscreenControl: false,
          scrollwheel: true,
          zoomControl: true,
          gestureHandling: true,
          draggable: true
        }}
      >
        {markers}
        {searchBox}
      </GoogleMap>
    );
  })
);

export default Map;



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/Map.js